import React from 'react';
import { Provider, observer } from 'mobx-react';
import { IntlProvider } from 'react-intl';
import { BrowserRouter, Switch, Route } from 'react-router-dom';
import boardLocales from '../../locales/board.json';
import { ROUTE_PATH } from './constants';
import LocaleStore from '../common_components/localization/LocaleStore';
import RootStore from './stores/RootStore';
import Show from './Show';
import { AxiosHelpers } from '../../libs/axios_csrf';

import MainTooltips from '../common_components/tooltips/MainTooltips';
import TooltipStore from '../common_components/tooltips/TooltipStore';
import { TOOLTIPPROPS } from './constantsTooltips';

@observer
export default class Main extends React.Component {
  constructor(props) {
    super(props);

    const localeStore = new LocaleStore(props.userLocale, [boardLocales]);
    this.rootStore = new RootStore(props, localeStore);
    this.authorizationStore = this.rootStore.authorizationStore;

    this.rootStore.fetchData();

    AxiosHelpers.avoidWindowLeave();
    props.initRootStore && props.initRootStore(this.rootStore);

    this.tooltipStore = new TooltipStore(this.rootStore, TOOLTIPPROPS);
    this.rootStore.tooltipStore = this.tooltipStore;
  }

  render() {
    return (
      <IntlProvider
        locale={this.rootStore.localeStore.locale}
        messages={this.rootStore.localeStore.messages}
      >
        <Provider rootStore={this.rootStore}>
          <div>
            <MainTooltips
              customJoyrideProps={{
                scrollToFirstStep: false,
                spotlightClicks: true,
              }}
            />

            <BrowserRouter>
              <Switch>
                <Route
                  path={'/'}
                  component={this.authorizationStore.authShow(Show, false, {
                    ...this.props.currentValuePropositionId,
                  })}
                />
              </Switch>
            </BrowserRouter>
          </div>
        </Provider>
      </IntlProvider>
    );
  }

  componentWillReceiveProps(nextProps) {
    if (
      nextProps.boardId !== this.rootStore.boardId ||
      nextProps.bmcUpdate !== this.props.bmcUpdate ||
      nextProps.isInclusiveBoard !== this.props.isInclusiveBoard ||
      nextProps.vp_id !== this.props.vp_id ||
      nextProps.mvp_id !== this.props.mvp_id ||
      nextProps.user_id !== this.props.user_id ||
      nextProps.dashboardType !== this.props.dashboardType
    ) {
      const localeStore = new LocaleStore(nextProps.userLocale, [boardLocales]);

      this.rootStore && this.rootStore.unsubscribeListener();
      this.rootStore = new RootStore(nextProps, localeStore);
      this.authorizationStore = this.rootStore.authorizationStore;
      this.rootStore.fetchData();
      AxiosHelpers.avoidWindowLeave();
      nextProps.initRootStore && nextProps.initRootStore(this.rootStore);
      this.rootStore.tooltipStore = this.tooltipStore;
    }
  }

  componentWillUnmount() {
    this.rootStore && this.rootStore.unsubscribeListener();
  }
}
